import { DEFAULT_CSS_CLASS } from '@constants';
import classnames from 'classnames';
import { getBlockClassNames } from '@components/class-dropdown';

const {
  blockEditor: { useBlockProps, InnerBlocks },
} = wp;

const Save = ({ attributes }) => {
  const { blockClassNames } = attributes;

  const defaultBlockCssClass = DEFAULT_CSS_CLASS.CARD;
  const classNames = getBlockClassNames(blockClassNames);

  const blockProps = useBlockProps.save({
    className: classnames({
      [`${defaultBlockCssClass}`]: true,
      [`${classNames}`]: classNames,
    }),
  });

  return (
    <div {...blockProps}>
      <InnerBlocks.Content />
    </div>
  );
};

export default Save;
